module.exports = __webpack_public_path__ + "img/nfd-logo-black_3.f175fb24.png";